import React, {Fragment} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {RadioFieldForm as RadioField} from 'app-ui-componentlibrary';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';
import {Loader, Card, Grid, Button, Popup, Icon} from 'semantic-ui-react';
import {
  onlyAllowNumbers,
  onlyTwoDecimals,
  safeSubstract,
  safeDivide,
  roundUpOrDown,
  safeAdd,
} from 'common/utils';
import {showDollarAmountWithDollar, fillArray} from 'common/utils';
import {InlineDollarFieldForm as InlineDollarField} from 'app-ui-componentlibrary';
import ReactHtmlParser from 'react-html-parser';
import REST from 'go/requests/rest';
import {SCOPE_OF_WORK_TOTAL, ALLOWED_EXCESS_TOTAL} from 'common/requestDetails/constants';

export class CostShareHeader extends React.Component {
  constructor(props) {
    super(props);
    const useActualPaths = _.get(this.props, 'useActualPaths');
    let costShare = _.get(this.props, 'data.share', undefined);
    let fedRates = _.get(costShare, useActualPaths ? 'actualFedRate' : 'fedRate', null);
    let fedShares = _.get(
      costShare,
      useActualPaths ? 'actualFedShare' : 'fedShare',
      null
    );
    let appShares = _.get(
      costShare,
      useActualPaths ? 'actualAppShare' : 'appShare',
      null
    );
    let appRates = _.get(costShare, useActualPaths ? 'actualAppRate' : 'appRate', null);

    const rules = _.get(this.props, 'rules');
    const matchingRules = _.filter(rules, (r) => {
      const prop = _.get(this.props, _.get(r, 'prop'));
      return _.includes(
        _.get(r, 'values', []),
        _.get(r, 'convertToInteger', false) ? _.toInteger(prop) : prop
      );
    });

    const rule = matchingRules.length ? matchingRules[0] : {};

    const alternateDisabled = _.get(rule, 'alternateDisabled', false);
    const justificationOptional = _.get(rule, 'justificationOptional', false);
    const alternateQuestion = _.get(rule, 'alternateQuestion');
    const isAlternateCostShare = alternateQuestion
      ? _.get(this.props, 'data.' + _.get(alternateQuestion, 'dataPath'), 'No')
      : 'No';

    const applicantRate =
      (appRates &&
        appRates.length > this.props.headerId && [appRates[this.props.headerId]]) ||
      null;
    const alternateRate = [_.get(rule, 'alternateRate', applicantRate)];
    const fedRate =
      (fedRates &&
        fedRates.length > this.props.headerId && [fedRates[this.props.headerId]]) ||
      null;

    const fedShare =
      (fedShares &&
        fedShares.length > this.props.headerId && [fedShares[this.props.headerId]]) ||
      null;

    const appShare =
      (appShares &&
        appShares.length > this.props.headerId && [appShares[this.props.headerId]]) ||
      null;

    const totalAmountCalc = this.getTotalAmountCalc();

    this.state = {
      totalActivityCosts: [totalAmountCalc],
      isAlternateCostShare,
      alternateDisabled,
      alternateQuestion,
      alternateCostShareQuestionDataPath: _.get(alternateQuestion, 'dataPath'),
      defaultApplicantRates: [_.get(rule, 'applicantRate', 0.25)],
      alternateApplicantRates: alternateRate,
      federalCostSharePercents:
        fedRate === null
          ? null
          : _.map(fedRate, (rate) => this.checkDecimal(rate * 100, false)),
      federalCostShareTotalAmounts: fedShare,
      nonFederalCostSharePercents:
        applicantRate === null
          ? null
          : _.map(applicantRate, (rate) => this.checkDecimal(rate * 100, true)),
      nonFederalCostShareTotalAmounts: appShare,
      justification: _.get(costShare, `justification${this.props.headerId}`, ''),
      isJustificationError: false,
      isJustificationRequired: false,
      justificationOptional,
      isRulesLoaded: true,
    };
  }

  justificationLabel =
    'Please provide justification for exceeding the allowable federal share here.';

  isJustificationRequired = false;

  componentDidMount() {
    if (
      this.state.totalActivityCosts &&
      this.state.totalActivityCosts[0] &&
      (this.state.nonFederalCostSharePercents === null ||
        this.state.federalCostSharePercents === null ||
        this.state.nonFederalCostShareTotalAmounts === null ||
        this.state.federalCostShareTotalAmounts === null)
    ) {
      this.calculateDefaultCostShare();
    }
    this.state.federalCostSharePercents &&
      this.checkForJustificationRequired(this.state.federalCostSharePercents);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !_.isEqual(this.props.fundingStreamDataPath, prevProps.fundingStreamDataPath) ||
      _.get(this.props, 'data.programIncome') != _.get(prevProps, 'data.programIncome')
    ) {
      const totalAmountCalc = this.getTotalAmountCalc();
      this.setState({totalActivityCosts: [totalAmountCalc]});
    }

    if (
      !_.isEqual(this.state.alternateApplicantRates, prevState.alternateApplicantRates) ||
      !_.isEqual(this.state.totalActivityCosts, prevState.totalActivityCosts)
    ) {
      if (
        this.state.federalCostSharePercents === null ||
        this.state.nonFederalCostSharePercents === null
      ) {
        this.calculateDefaultCostShare();
      } else {
        const totalAmountChanged =
          _.get(this.state, 'totalActivityCosts.0') ===
          _.get(prevState, 'totalActivityCosts.0');
        this.handleNonFedShareChange(
          this.state.nonFederalCostSharePercents,
          totalAmountChanged
            ? _.get(this.state, 'nonFederalCostShareTotalAmounts.0')
            : null,
          0
        );
        this.checkForJustificationRequired(this.state.federalCostSharePercents);
      }
    } else {
      if (!_.isEqual(this.state.isAlternateCostShare, prevState.isAlternateCostShare)) {
        if (this.state.alternateDisabled) {
          const {entityType, entityDataPath} = this.props;
          this.props.saveEntityData(
            entityDataPath + '.' + this.state.alternateCostShareQuestionDataPath,
            entityType,
            this.state.isAlternateCostShare,
            false,
            null,
            this.props.entityTypeReduxPath
          );
        } else {
          this.calculateDefaultCostShare();
        }
      }
    }
  }

  getTotalAmountCalc() {
    const {fundingStreamDataPath, itemCode, subtractProgramIncome, useActualPaths} =
      this.props;

    const matchingItems = _.map(fundingStreamDataPath, (fs) => {
      const children = _.filter(fs.children, (child) => {
        return child.itemCode === itemCode;
      });
      return {...fs, children};
    });

    const totalAmounts = _.map(matchingItems, (fs) => {
      let itemTotal = 0;
      _.forEach(fs.children, (child) => {
        _.forEach(child.children, (item) => {
          _.forEach(item.cost, (costItem) => {
            let ineligible = _.get(item, 'additionalInformation.ineligible');
            let deferred = _.get(item, 'additionalInformation.deferred');
            if (!ineligible && !deferred) {
              itemTotal += _.reduce(
                costItem,
                (total, cost) =>
                  total +
                  (useActualPaths &&
                  _.toString(_.get(cost, ALLOWED_EXCESS_TOTAL)) &&
                  _.toString(_.get(cost, SCOPE_OF_WORK_TOTAL))
                    ? safeAdd(
                        _.get(cost, ALLOWED_EXCESS_TOTAL),
                        _.get(cost, SCOPE_OF_WORK_TOTAL)
                      )
                    : useActualPaths
                    ? cost.actualTotal
                    : cost.total),
                0
              );
            }
          });
        });
      });
      return itemTotal;
    });

    let totalAmountCalc = _.reduce(totalAmounts, (total, amount) => total + amount, 0);

    if (subtractProgramIncome) {
      const programIncome = _.get(this.props, 'data.programIncome', 0);
      totalAmountCalc -= _.toNumber(programIncome !== '' ? programIncome : 0);
    }

    return totalAmountCalc;
  }

  calculateDefaultCostShare() {
    let applicableApplicantRates =
      _.isEqual(this.state.isAlternateCostShare, 'Yes') &&
      _.isEqual(this.state.alternateDisabled, false)
        ? this.state.alternateApplicantRates
        : this.state.defaultApplicantRates;

    let federalCostSharePercents = _.map(
      applicableApplicantRates,
      (rate) => (1 - rate) * 100
    );
    let nonFederalCostSharePercents = _.map(
      applicableApplicantRates,
      (rate) => rate * 100
    );

    let federalCostShareTotalAmounts = _.map(
      _.get(this.state, 'totalActivityCosts', [0]),
      (totalCost, index) => totalCost * (1 - _.get(applicableApplicantRates, index))
    );
    let nonFederalCostShareTotalAmounts = _.map(
      _.get(this.state, 'totalActivityCosts', [0]),
      (totalCost, index) => totalCost * _.get(applicableApplicantRates, index)
    );

    if (!this.props.readOnly) {
      this.validateAndSaveData(
        _.map(federalCostSharePercents, (value) => this.checkDecimal(value, false)),
        _.map(federalCostShareTotalAmounts, (value) => this.checkDecimal(value, false)),
        _.map(nonFederalCostSharePercents, (value) => this.checkDecimal(value, true)),
        _.map(nonFederalCostShareTotalAmounts, (value) => this.checkDecimal(value, true))
      );
    }
  }

  handleFedShareChange = (fedSharePerc, fedShareAmt, index) => {
    if (fedSharePerc == null && fedShareAmt == null) {
      return;
    }

    if (fedSharePerc !== null) {
      fedSharePerc = this.validatePercentageFormat(fedSharePerc);
      // Floor the federal amount rather than rounding it half-up: the applicant
      // share is this figure subtracted from the total, so half-up hands FEMA
      // the extra half cent. Floor here matches the 'ceil' the non-federal
      // handler below already uses, and the floor/ceil pair checkDecimal applies
      // to the defaults. GMMGO-68427.
      fedShareAmt = roundUpOrDown(
        'floor',
        (fedSharePerc * this.state.totalActivityCosts[index]) / 100,
        2
      );
    } else {
      fedSharePerc = ((fedShareAmt * 100) / this.state.totalActivityCosts[index]).toFixed(
        2
      );
    }

    var tmpval = 0;
    var nonFedSharePerc =
      (tmpval = safeSubstract(100, fedSharePerc)) < 0 ? 0 : tmpval.toFixed(2);
    var nonFedShareAmt =
      (tmpval = safeSubstract(this.state.totalActivityCosts[index], fedShareAmt)) < 0
        ? 0
        : tmpval.toFixed(2);

    var fedSharePercents = [...this.state.federalCostSharePercents];
    var fedShareAmounts = _.isEmpty(this.state.federalCostShareTotalAmounts)
      ? []
      : [...this.state.federalCostShareTotalAmounts];
    var nonFedShareAmounts = _.isEmpty(this.state.nonFederalCostShareTotalAmounts)
      ? []
      : [...this.state.nonFederalCostShareTotalAmounts];
    var nonFedSharePercents = [...this.state.nonFederalCostSharePercents];

    fedSharePercents[index] = fedSharePerc;
    fedShareAmounts[index] = fedShareAmt;
    nonFedSharePercents[index] = nonFedSharePerc;
    nonFedShareAmounts[index] = nonFedShareAmt;

    this.validateAndSaveData(
      fedSharePercents,
      fedShareAmounts,
      nonFedSharePercents,
      nonFedShareAmounts
    );
  };

  handleNonFedShareChange = (nonFedSharePerc, nonFedShareAmt, index) => {
    if (nonFedSharePerc == null && nonFedShareAmt == null) {
      return;
    }
    if (nonFedShareAmt !== null && nonFedShareAmt !== undefined) {
      nonFedSharePerc = (
        (nonFedShareAmt * 100) /
        this.state.totalActivityCosts[index]
      ).toFixed(2);
    } else if (nonFedSharePerc !== null) {
      nonFedSharePerc = this.validatePercentageFormat(nonFedSharePerc);
      nonFedShareAmt = roundUpOrDown(
        'ceil',
        (nonFedSharePerc * this.state.totalActivityCosts[index]) / 100,
        2
      ).toString();
    }

    var tmpval = 0;
    var fedSharePerc =
      (tmpval = safeSubstract(100, nonFedSharePerc)) < 0 ? 0 : tmpval.toFixed(2);
    var fedShareAmt =
      (tmpval = safeSubstract(this.state.totalActivityCosts[index], nonFedShareAmt)) < 0
        ? 0
        : tmpval.toFixed(2);

    var fedSharePercents = [...this.state.federalCostSharePercents];
    var fedShareAmounts = _.isEmpty(this.state.federalCostShareTotalAmounts)
      ? []
      : [...this.state.federalCostShareTotalAmounts];
    var nonFedShareAmounts = _.isEmpty(this.state.nonFederalCostShareTotalAmounts)
      ? []
      : [...this.state.nonFederalCostShareTotalAmounts];
    var nonFedSharePercents = [...this.state.nonFederalCostSharePercents];

    fedSharePercents[index] = fedSharePerc;
    fedShareAmounts[index] = fedShareAmt;
    nonFedSharePercents[index] = nonFedSharePerc;
    nonFedShareAmounts[index] = nonFedShareAmt;

    this.validateAndSaveData(
      fedSharePercents,
      fedShareAmounts,
      nonFedSharePercents,
      nonFedShareAmounts
    );
  };

  handleJustificationOnBlur = () => {
    this.props.saveEntityData(
      this.props.entityDataPath + '.share.justification' + this.props.headerId,
      this.props.entityType,
      this.state.justification,
      'costShareHeader_justification' + this.props.headerId,
      null,
      this.props.entityTypeReduxPath
    );
  };

  checkForJustificationRequired = (fedSharePercents) => {
    let isJustificationRequired = false;
    _.map(fedSharePercents, (percent, index) => {
      if (
        _.isEqual(this.state.isAlternateCostShare, 'Yes') &&
        !this.state.alternateDisabled
      ) {
        isJustificationRequired =
          percent > (1 - this.state.alternateApplicantRates[index]) * 100 ? true : false;
      } else {
        isJustificationRequired =
          percent > (1 - this.state.defaultApplicantRates[index]) * 100 ? true : false;
      }
    });

    this.setState({isJustificationRequired});

    if (!isJustificationRequired) {
      this.setState({justification: ''});
    }
  };

  getErrorObject = (field) => {
    let Error = {
      isValid: true,
      message: '',
    };
    const {validationErrors, validationDirtyMap, validationErrorPath} = this.props;

    if (validationErrors.isLoading) return Error;

    if (validationErrorPath) {
      field = `${validationErrorPath}.${field}`;
    }

    const headerId = _.get(this.props, 'headerId', '');

    if (_.isEqual(field, `costShareHeader_justification${headerId}`)) {
      const isDirty = _.get(
        validationDirtyMap,
        `costShareHeader_justification${headerId}`
      );
      if (this.state.isAlternateCostShare === 'Yes') {
        Error = isDirty
          ? _.get(
              validationErrors.errors,
              `costShareHeader_justification${headerId}.1`,
              Error
            )
          : Error;
      } else {
        Error = isDirty
          ? _.get(
              validationErrors.errors,
              `costShareHeader_justification${headerId}.0`,
              Error
            )
          : Error;
      }
    } else {
      Error = _.get(validationErrors.errors, field + '.0', Error);
    }

    if (
      _.isEqual(field, `costShareHeader_justification${headerId}`) &&
      this.state.justification.length < 1
    ) {
      Error = _.get(validationErrors.errors, `costShareHeader_justification${headerId}`);
      if (_.isArray(Error)) {
        let result = _.find(Error, (error) => !error.isValid);
        if (result) {
          Error = result;
        } else {
          Error = Error[0];
        }
      }
    }

    return Error;
  };

  validatePercentageFormat = (value, prevValue) => {
    if (typeof value !== 'undefined' && value !== null) {
      value = onlyAllowNumbers(value);
      // strip hyphens (allowed as numbers)
      value = value.replace(/-/g, '');
      value = onlyTwoDecimals(value);
    }
    return value;
  };

  validateAndSaveData(
    fedSharePercents,
    fedShareAmounts,
    nonFedSharePercents,
    nonFedShareAmounts
  ) {
    this.checkForJustificationRequired(fedSharePercents);

    this.setState({
      federalCostSharePercents: fedSharePercents,
      federalCostShareTotalAmounts: fedShareAmounts,
      nonFederalCostSharePercents: nonFedSharePercents,
      nonFederalCostShareTotalAmounts: nonFedShareAmounts,
    });
    if (!this.props.readOnly) {
      this.saveData(
        fedSharePercents,
        nonFedSharePercents,
        fedShareAmounts,
        nonFedShareAmounts
      );
    }
    this.props.updateNonFedShare(nonFedShareAmounts);
  }

  isWithinPercentageLimits = (value) => {
    return value < 0 || value > 100 ? false : true;
  };

  // Limits to 2 decimals. Adds .00 if no decimal
  checkDecimal = (value, isRoundUp) => {
    if (value !== undefined && value !== null) {
      value = roundUpOrDown(isRoundUp ? 'ceil' : 'floor', parseFloat(value), 2);
    }
    return value;
  };

  saveData = (
    federalCostSharePercents,
    nonFederalCostSharePercents,
    federalCostShareTotalAmounts,
    nonFederalCostShareTotalAmounts
  ) => {
    const {entityType, entityDataPath, headerId, handlePostSave, useActualPaths} =
      this.props;
    const costShare = _.get(this.props, 'data.share', undefined);
    const fedRates = _.get(costShare, useActualPaths ? 'actualFedRate' : 'fedRate', []);
    const fedShares = _.get(
      costShare,
      useActualPaths ? 'actualFedShare' : 'fedShare',
      []
    );
    const appShares = _.get(
      costShare,
      useActualPaths ? 'actualAppShare' : 'appShare',
      []
    );
    const appRates = _.get(costShare, useActualPaths ? 'actualAppRate' : 'appRate', []);
    const totalAmounts = _.get(costShare, 'totalAmounts', []);

    const newFedRates = [...fedRates];

    newFedRates[headerId] = roundUpOrDown(
      'floor',
      safeDivide(federalCostSharePercents[0], 100),
      4
    ).toString();

    this.props.saveEntityData(
      entityDataPath + (useActualPaths ? '.share.actualFedRate' : '.share.fedRate'),
      entityType,
      newFedRates,
      false,
      null,
      this.props.entityTypeReduxPath
    );

    const newAppRates = [...appRates];

    newAppRates[headerId] = roundUpOrDown(
      'ceil',
      safeDivide(nonFederalCostSharePercents[0], 100),
      4
    ).toString();

    this.props.saveEntityData(
      entityDataPath + (useActualPaths ? '.share.actualAppRate' : '.share.appRate'),
      entityType,
      newAppRates,
      false,
      null,
      this.props.entityTypeReduxPath
    );

    const newFedShares = [...fedShares];

    newFedShares[headerId] = federalCostShareTotalAmounts[0];

    this.props.saveEntityData(
      entityDataPath + (useActualPaths ? '.share.actualFedShare' : '.share.fedShare'),
      entityType,
      fillArray(newFedShares, '0.00'),
      false,
      null,
      this.props.entityTypeReduxPath
    );

    const newAppShares = [...appShares];

    newAppShares[headerId] = nonFederalCostShareTotalAmounts[0];

    this.props.saveEntityData(
      entityDataPath + (useActualPaths ? '.share.actualAppShare' : '.share.appShare'),
      entityType,
      fillArray(newAppShares, '0.00'),
      false,
      null,
      this.props.entityTypeReduxPath
    );

    const newTotalAmounts = [...totalAmounts];

    newTotalAmounts[headerId] = this.state.totalActivityCosts[0].toFixed(2).toString();

    this.props.saveEntityData(
      entityDataPath + '.share.totalAmounts',
      entityType,
      fillArray(newTotalAmounts, '0.00'),
      false,
      null,
      this.props.entityTypeReduxPath
    );

    this.props.saveEntityData(
      entityDataPath + '.' + this.state.alternateCostShareQuestionDataPath,
      entityType,
      this.state.isAlternateCostShare,
      false,
      null,
      this.props.entityTypeReduxPath
    );

    this.props.saveEntityData(
      entityDataPath + `.share.justification${this.props.headerId}`,
      entityType,
      this.state.justification,
      false,
      null,
      this.props.entityTypeReduxPath
    );

    if (this.props.entityTypeReduxPath) {
      handlePostSave(this.props.entityTypeReduxPath);
    }
  };

  handleAlternateCostShareChange(e) {
    this.setState({
      isAlternateCostShare: _.get(e, 'target.value'),
    });
  }

  getImpoverishedToolTipContent() {
    return (
      <Grid centered divided columns={1}>
        <Grid.Column>
          <div>
            <br />
            <strong>Small impoverished community</strong>
            <br />
            <br />
            <p>
              A Small and Impoverished Community must meet all of the following criteria:
            </p>
            <ul>
              <li>
                It must be economically disadvantaged, with residents having an average
                per capita annual income not exceeding 80 percent of national per capita
                income based on best available data. It must meet any other factors
                identified in the mitigation plan in which the community is located.
              </li>
              <li>
                If Yes is selected, the default Federal Share and Non-Federal Share
                percentage (75%/25%) changes to 90%/10%. If No is selected, the default
                value of Federal Share Percentage and Non-Federal Percentage is retained.
              </li>
              <li>
                It must have a local unemployment rate that exceeds by one percentage
                point or more, the most recently reported, average yearly national
                unemployment rate; and
              </li>
              <li>
                It must be a community of 3,000 or fewer individuals that are identified
                by the State as a rural community and is not a remote area within the
                corporate boundaries of a larger city.
              </li>
            </ul>
          </div>
        </Grid.Column>
      </Grid>
    );
  }

  getAlternateCostShareQuestion() {
    const {alternateQuestion} = this.state;
    const alternateQuestionText = _.get(alternateQuestion, 'question');
    const explanation = _.get(alternateQuestion, 'explanation');
    const explanationLabel = _.get(alternateQuestion, 'explanationLabel');

    return (
      <Fragment>
        <a color="blue" className={`budget-cs-font-size`}>
          <Popup
            hideOnScroll
            on={['click', 'focus', 'hover']}
            position="bottom left"
            wide="very"
            content={
              <Grid centered divided columns={1}>
                <Grid.Column>{ReactHtmlParser(explanation)}</Grid.Column>
              </Grid>
            }
            trigger={
              <div tabIndex={0}>
                <strong>{`${alternateQuestionText} `}</strong>
                <Icon
                  name="info circle"
                  color="blue"
                  label={explanationLabel}
                  title={explanationLabel}
                />
              </div>
            }
          />
        </a>
        This determines your federal/non-federal share ratio. <br />
      </Fragment>
    );
  }

  render() {
    const {isLoaded, readOnly = false} = this.props;
    const headerId = _.get(this.props, 'headerId', '');
    const {totalActivityCosts} = this.state;
    const fedPercentError = this.getErrorObject(
      `costShareHeader_fedSharePercent${headerId}`
    );
    const nonFedPercentError = this.getErrorObject(
      `costShareHeader_nonFedSharePercent${headerId}`
    );

    if (!totalActivityCosts || !totalActivityCosts[0]) {
      return null;
    }

    return isLoaded && this.state.isRulesLoaded ? (
      <React.Fragment>
        <br />
        <b>{this.props.header}</b>
        <Card fluid className={`budget-cs-background-color`}>
          <Grid>
            <Grid.Row className={`shares noTopPadding budget-cs-padding-left`}>
              {this.state.alternateQuestion && (
                <Grid.Column width={5} className="left-side">
                  {this.getAlternateCostShareQuestion()}
                  {!readOnly ? (
                    <RadioField
                      name={'alternate_costshare_' + (this.props.costShareIndex ?? 0)}
                      id={'alternate_costshare_' + (this.props.costShareIndex ?? 0)}
                      value={this.state.isAlternateCostShare}
                      options={[
                        {label: 'Yes', value: 'Yes'},
                        {label: 'No', value: 'No'},
                      ]}
                      handleChange={(e) => this.handleAlternateCostShareChange(e)}
                    />
                  ) : (
                    this.state.isAlternateCostShare
                  )}
                </Grid.Column>
              )}
              <Grid.Column
                width={this.state.alternateQuestion ? 10 : 15}
                className={`${
                  this.state.alternateQuestion && 'right-side'
                } budget-cs-padding-bottom budget-cs-padding-top--double`}
              >
                <Grid>
                  <Grid.Row className={`noBottomPadding`}>
                    <Grid columns={4}>
                      <Grid.Column width={3} className={`noBottomPadding`} />
                      <Grid.Column width={5} className={`noBottomPadding`} />
                      <Grid.Column
                        width={3}
                        className={`noPadding budget-cs-padding-right`}
                      >
                        <span className={`budget-cs-smaller-font-size`}>
                          <strong>% Percentage</strong>
                        </span>
                      </Grid.Column>
                      <Grid.Column width={4} className={`noPadding`}>
                        <span className={`budget-cs-smaller-font-size`}>
                          <strong>$ Dollar amount</strong>
                        </span>
                      </Grid.Column>
                    </Grid>
                  </Grid.Row>
                  <Grid.Row className={`noTopPadding noBottomPadding`}>
                    <Grid columns={4}>
                      <Grid.Column width={3} className={`noBottomPadding`} />
                      <Grid.Column width={5} className={`budget-cs-padding-top`}>
                        <strong>Proposed federal share</strong>
                      </Grid.Column>
                      <Grid.Column
                        width={3}
                        className={`budget-cs-padding-top  budget-cs-padding-right`}
                      >
                        <div
                          className={!fedPercentError.isValid ? 'errorBorderLine' : ''}
                        >
                          <strong
                            id="federalSharePerc"
                            className={!fedPercentError.isValid ? 'errorFieldBorder' : ''}
                          >
                            {_.get(this.state, 'federalCostSharePercents.0')}
                          </strong>
                          {!fedPercentError.isValid && (
                            <div className={`errorMessages`}>
                              {fedPercentError.message}
                            </div>
                          )}
                        </div>
                      </Grid.Column>
                      <Grid.Column
                        width={4}
                        className={`noPadding ${
                          readOnly ? 'budget-cs-padding-top budget-cs-padding-right' : ''
                        } `}
                      >
                        {!readOnly ? (
                          <InlineDollarField
                            size="default"
                            id="federalShareDollar"
                            name="federalShareDollar"
                            value={_.get(this.state, 'federalCostShareTotalAmounts.0')}
                            handleChange={(name, value) => {
                              this.handleFedShareChange(null, value, 0);
                            }}
                            handleBlur={() => {}}
                            displayError={
                              !this.getErrorObject(
                                `costShareHeader_fedShareAmount${headerId}`
                              ).isValid
                            }
                            errorMessages={
                              this.getErrorObject(
                                `costShareHeader_fedShareAmount${headerId}`
                              ).message
                            }
                          />
                        ) : (
                          <strong>
                            {_.get(this.state, 'federalCostShareTotalAmounts.0')}
                          </strong>
                        )}
                      </Grid.Column>
                    </Grid>
                  </Grid.Row>
                  <Grid.Row className={`noTopPadding noBottomPadding`}>
                    <Grid columns={4}>
                      <Grid.Column width={3} className={`noBottomPadding`} />
                      <Grid.Column
                        width={5}
                        className={`budget-cs-padding-top noBottomPadding`}
                      >
                        <strong>Proposed non-federal share</strong>
                      </Grid.Column>
                      <Grid.Column
                        width={3}
                        className={`budget-cs-padding-top noBottomPadding budget-cs-padding-right`}
                      >
                        <div
                          className={!nonFedPercentError.isValid ? 'errorBorderLine' : ''}
                        >
                          <strong
                            id="nonFederalSharePerc"
                            className={
                              !nonFedPercentError.isValid ? 'errorFieldBorder' : ''
                            }
                          >
                            {_.get(this.state, 'nonFederalCostSharePercents.0')}
                          </strong>
                          {!nonFedPercentError.isValid && (
                            <div className={`errorMessages`}>
                              {nonFedPercentError.message}
                            </div>
                          )}
                        </div>
                      </Grid.Column>
                      <Grid.Column
                        width={4}
                        className={`noPadding ${
                          readOnly ? 'budget-cs-padding-top budget-cs-padding-right' : ''
                        } `}
                      >
                        {!readOnly ? (
                          <InlineDollarField
                            size="default"
                            id="nonFederalShareDollar"
                            name="nonFederalShareDollar"
                            value={_.get(this.state, 'nonFederalCostShareTotalAmounts.0')}
                            handleChange={(name, value) => {
                              this.handleNonFedShareChange(null, value, 0);
                            }}
                            handleBlur={() => {}}
                            displayError={
                              !this.getErrorObject(
                                `costShareHeader_nonFedShareAmount${headerId}`
                              ).isValid
                            }
                            errorMessages={
                              this.getErrorObject(
                                `costShareHeader_nonFedShareAmount${headerId}`
                              ).message
                            }
                          />
                        ) : (
                          <strong>
                            {_.get(this.state, 'nonFederalCostShareTotalAmounts.0')}
                          </strong>
                        )}
                      </Grid.Column>
                    </Grid>
                  </Grid.Row>
                  <Grid.Row className={`noTopPadding`}>
                    <Grid columns={4}>
                      <Grid.Column width={3} className={`noBottomPadding`} />
                      <Grid.Column width={5} className={`noTopPadding`} />
                      <Grid.Column
                        width={3}
                        className={`noPadding budget-cs-padding-right`}
                      />
                      <Grid.Column width={4} className={`noPadding`}>
                        <div className={`text-align-right budget-cs-smaller-font-size`}>
                          <strong>
                            Based on total budget cost:{' '}
                            {showDollarAmountWithDollar(totalActivityCosts[0].toFixed(2))}
                          </strong>
                        </div>
                      </Grid.Column>
                    </Grid>
                  </Grid.Row>
                  {this.state.isJustificationRequired && (
                    <Grid.Row>
                      <Grid.Column width={13} className={`noTopPadding`}>
                        <span id="justificationLabel">
                          <strong>
                            {this.justificationLabel}{' '}
                            {this.state.justificationOptional && '(Optional)'}
                          </strong>
                        </span>
                        {!readOnly ? (
                          <TextAreaField
                            rows={4}
                            maxLength={4001}
                            title="Justification"
                            label=""
                            id="justification"
                            name="justification"
                            value={this.state.justification}
                            handleChange={(e, data) =>
                              this.setState({justification: data.value})
                            }
                            handleBlur={this.handleJustificationOnBlur}
                            displayError={
                              !this.getErrorObject(
                                `costShareHeader_justification${headerId}`
                              ).isValid
                            }
                            errorMessages={
                              this.getErrorObject(
                                `costShareHeader_justification${headerId}`
                              ).message
                            }
                          />
                        ) : (
                          <Fragment>
                            <br /> <br />
                            {this.state.justification}
                          </Fragment>
                        )}
                      </Grid.Column>
                    </Grid.Row>
                  )}
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
      </React.Fragment>
    ) : (
      <Loader inline="centered" active>
        Loading...
      </Loader>
    );
  }
}

export const mapStateToProps = (state) => ({
  dynamicComponent: state.dynamicComponent,
  context: state.dynamicComponent.context,
  jwt: state.auth.token,
});

export default connect(mapStateToProps, null)(connectDynamic(CostShareHeader));
